import React from "react";
import {AC_DEV_LEVEL, PAYMENT_TYPE, SUBSCRIPTION_ROOT_PAGES, VDS_LEVEL, VRI_LEVEL} from "../../../constants";
import PlanHeaderNotes from "../../common/subscriptions/PlanHeaderNotes";

const HomeContainer = ({ rootPage, settings, appCenterData, vriData, vdsData, setRootPage }) => {

    const isBasic = appCenterData?.devLevel === AC_DEV_LEVEL.BASIC;
    const hasNoneVRI = vriData?.level === VRI_LEVEL.NONE;
    const hasNoneVDS = vdsData?.level === VDS_LEVEL.NONE;

    if (!settings || !appCenterData || rootPage !== SUBSCRIPTION_ROOT_PAGES.HOME)
        return <></>;

    const vriSubtitle = hasNoneVRI ? i18n.payments.vri.productNote : null;
    const vdsSubtitle = hasNoneVDS ? i18n.payments.vds.productNote : null;

    return (
        <div className={`plan-container flexColumn`}>
            {
                isBasic && hasNoneVRI && hasNoneVDS && (
                    <div style={{ marginBottom: '0.75em', fontWeight: 'bold', fontSize: '1.5em' }}>
                        {i18n.payments.newSubscriptionUserNote}
                    </div>
                )
            }

            {
                !isBasic && (
                    <PlanHeaderNotes title={i18n.payments.ac.title}
                                     paymentType={PAYMENT_TYPE.AC}
                                     onPaymentTypeClick={() => setRootPage(SUBSCRIPTION_ROOT_PAGES.AC)}
                                     data={appCenterData}/>
                )
            }

            <PlanHeaderNotes title={i18n.payments.vri.title}
                             subtitle={vriSubtitle}
                             paymentType={PAYMENT_TYPE.VRI}
                             onPaymentTypeClick={() => setRootPage(SUBSCRIPTION_ROOT_PAGES.VRI)}
                             data={vriData}/>

            <PlanHeaderNotes title={i18n.payments.vds.title}
                             subtitle={vdsSubtitle}
                             paymentType={PAYMENT_TYPE.VDS}
                             onPaymentTypeClick={() => setRootPage(SUBSCRIPTION_ROOT_PAGES.VDS)}
                             data={vdsData}/>
        </div>
    );
};

export default HomeContainer;